import { HttpClient } from '@angular/common/http'
import { environment } from 'src/environments/environment'
import { Injectable } from '@angular/core'
import { PaisSensedia } from '../models/pais-sensedia'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

interface PaisIbge {
  name: {
    common: string
  }
  cca2: string
}

@Injectable({
  providedIn: 'root',
})
export class ExternalAPIService {
  constructor(private readonly http: HttpClient) {}

  private readonly sensediaUrl = environment.sensediaUrl

  obterPaises(): Observable<PaisSensedia[]> {
    return this.http.get<PaisSensedia[]>(`${this.sensediaUrl}/dados-publicos/v1/pais/siglas-paises`)
  }

  obterPaisesV2(): Observable<PaisSensedia[]> {
    return this.http.get<PaisIbge[]>("https://restcountries.com/v3.1/all?fields=name,cca2").pipe(
      map(paises => paises.map(pais => ({
        sigla: pais.cca2,
        pais: pais.name.common
      })).sort((a, b) => a.pais.localeCompare(b.pais)))
    )
  }
}
